import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import { createPinia } from "pinia"; // Import Pinia
import "./assets/scss/main.scss";

// import "./styles.css"; // Import your global styles
import "@mdi/font/css/materialdesignicons.css";
import VueApexCharts from "vue3-apexcharts";

// Font Awesome Core
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Font Awesome Icons
import {
  faReddit,
  faYoutube,
  faTiktok,
  faPinterest,
} from "@fortawesome/free-brands-svg-icons";
import { faImage } from "@fortawesome/free-solid-svg-icons"; // Correct import for "image" icon

// Add icons to the library
library.add(faReddit, faYoutube, faTiktok, faPinterest, faImage);

// Load Fonts
loadFonts();

// Create Vue App
const app = createApp(App);

// Register Font Awesome Icon Component Globally
app.component("font-awesome-icon", FontAwesomeIcon);

// Use Plugins
app.use(createPinia()); // Use Pinia store
app.use(vuetify);
app.use(router);
app.use(VueApexCharts);

// Mount App
app.mount("#app");
